import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./Modal.css";

/**
 * Base Modal Component - Responsive and accessible
 * Uses React Portal to render to document.body
 */
const Modal = ({
    isOpen,
    onClose,
    children,
    size = "md",
    closeOnOverlayClick = true,
    closeOnEsc = true,
    className = "",
}) => {
    // Handle ESC key press
    useEffect(() => {
        if (!isOpen || !closeOnEsc) return;

        const handleEscape = (e) => {
            if (e.key === "Escape") {
                onClose();
            }
        };

        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
    }, [isOpen, closeOnEsc, onClose]);

    // Prevent body scroll when modal is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const handleOverlayClick = (e) => {
        if (e) {
            e.stopPropagation();
            if (e.nativeEvent) {
                e.nativeEvent.stopImmediatePropagation();
            }
        }
        if (closeOnOverlayClick && e.target === e.currentTarget) {
            onClose();
        }
    };

    const modalContent = (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className={`modal-container modal-${size} ${className}`} tabIndex="-1">
                {children}
            </div>
        </div>
    );

    return createPortal(modalContent, document.body);
};

export default Modal;
